<script lang="ts">
	import { classes } from '$lib/utils';
	import { createEventDispatcher } from 'svelte';

	export let value: string;
	export let label: string = '';
	export let placeholder: string;
	export let type: string;
	export let id: string;
	export let additionalClass = '';
	export let focused = false;
	export let errorMessage = 'This field should be filled in';
	export let darkMode = false;
	export let errorClass = '';
	export let hasError = false;
	export let disabled = false;

	let input: HTMLInputElement;

	const dispatch = createEventDispatcher();

	$: {
		if (input && focused) {
			input.focus();
		}
	}

	function typeAction(node: HTMLInputElement) {
		node.type = type;
	}
</script>

<!-- Placeholder: gray lighter -->
<div>
	{#if label}
		<label for={id} class="block mb-1 text-sm font-medium text-gray-900">{label}</label>
	{/if}
	<div class="flex flex-col gap-2">
		<input
			bind:this={input}
			{id}
			{placeholder}
			class={classes(
				'block py-2.5 px-0 w-full text-sm rounded-none disabled:opacity-75 bg-transparent border-0 border-b appearance-none focus:outline-none focus:ring-0 focus:border-purple',
				hasError ? errorClass : '',
				darkMode
					? 'text-white border-white placeholder:text-white'
					: 'text-black border-black placeholder:text-black',
				additionalClass
			)}
			{disabled}
			use:typeAction
			bind:value
			on:input={() => dispatch('input', value)}
			{...$$restProps}
		/>
		{#if hasError}
			<span class="text-error">{errorMessage}</span>
		{/if}
	</div>
</div>
